// extracted by mini-css-extract-plugin
export default {"tooltip":"ao-z","sharingV2":"bo-z","sharingIconsV2":"co-z","links":"do-z","link":"eo-z","facebookV2":"fo-z","twitterV2":"go-z","pinterestV2":"ho-z"};